import { render, staticRenderFns } from "./Criar-Turma.vue?vue&type=template&id=9d5037a8&"
import script from "./Criar-Turma.vue?vue&type=script&lang=js&"
export * from "./Criar-Turma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Turma.vue"
export default component.exports